// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UiTag_wrapper__1X8RU"};